import React from 'react';
import Button from '../../../components/ui/Button';
import Badge from '../../../components/ui/Badge';

const BulkActions = ({ selectedCount, onClearSelection, onBulkAction }) => {
  if (selectedCount === 0) return null;

  return (
    <div className="bg-primary-50 border border-primary-200 rounded-lg p-4 mb-6">
      <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
        <div className="flex items-center gap-3">
          <Badge variant="primary-solid" size="lg">
            {selectedCount} selected
          </Badge>
          <Button
            variant="ghost"
            size="sm"
            onClick={onClearSelection}
            iconName="X"
            iconPosition="left"
          >
            Clear
          </Button>
        </div>
        <div className="flex flex-wrap gap-2">
          <Button
            variant="primary"
            size="sm"
            onClick={() => onBulkAction('edit')}
            iconName="Edit"
            iconPosition="left"
          >
            Edit
          </Button>
          <Button
            variant="warning"
            size="sm"
            onClick={() => onBulkAction('risk')}
            iconName="AlertTriangle"
            iconPosition="left"
          >
            Set Risk Level
          </Button>
          <Button
            variant="danger"
            size="sm"
            onClick={() => onBulkAction('delete')}
            iconName="Trash2"
            iconPosition="left"
          >
            Delete
          </Button>
        </div>
      </div>
    </div>
  );
};

export default BulkActions;